import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import { isAfter, eachDayOfInterval, subDays, format } from "date-fns";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  TimePicker,
  DatePicker
} from "material-ui-pickers";
import qs from "qs";
import { CSVLink, CSVDownload } from "react-csv";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TableContainer from "@material-ui/core/TableContainer";

const styles = theme => ({
  container: {
    marginTop: 0
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  },
  grid: {
    width: "100%",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  button: {
    height: 40,
    margin: theme.spacing.unit
  },
  datePicker: {
    margin: theme.spacing.unit * 2
  },
  formControl: {
    margin: 16,
    minWidth: 178
  },
  textField: {
    margin: 16,
    minWidth: 178
  },
  container: {
    maxHeight: 1000
  }
});

const generateTableHead = ({ start, end }) => {
  const ret = eachDayOfInterval({
    start: new Date(start),
    end: new Date(end)
  }).map(d => (
    <TableCell align="right" key={d}>
      {format(new Date(d), "MMM, dd")}
    </TableCell>
  ));
  return ret;
};

class GarminSDK extends Component {
  state = {
    selectedStartDate: subDays(new Date().setHours(0, 0, 0, 0), 6),
    selectedEndDate: new Date(),
    start: subDays(new Date().setHours(0, 0, 0, 0), 6),
    end: new Date(),
    users: [],
    csvData: [],
    frequency: "1d",
    csvDataByReceiveDate: [],
    receivedatestart: 3,
    receivedateend: 3
  };

  handleStartDateChange = date => {
    this.setState({ selectedStartDate: format(date, "yyyy-MM-dd") });
  };

  handleEndDateChange = date => {
    this.setState({ selectedEndDate: format(date, "yyyy-MM-dd") });
  };

  downloadCSVByReceiveDate = async () => {
    const uniqid = this.props.uniqid;
    const start = this.state.receivedatestart;
    const end = this.state.receivedateend;
    const frequency = this.state.frequency;
    const resource = this.props.resource;
    try {
      const result = await fetch(`/api/downloadResourceCSVByReceiveDate`, {
        method: "POST",
        body: JSON.stringify({
          uniqid,
          resource,
          start,
          end,
          frequency,
        }), // data can be `string` or {object}!
        headers: new Headers({
          "Content-Type": "application/json"
        })
      });

      const data = await result.json();

      this.setState({ csvDataByReceiveDate: data }, () => {
        let btn = this.refs.csvByReceiveDate;
        btn.link.click();
      });
    } catch (err) {
      console.log(err);
    }
  };

  handlePickerOnClick = () => {
    let start = this.state.selectedStartDate;
    let end = this.state.selectedEndDate;

    if (isAfter(new Date(start), new Date(end))) {
      let tmp = start;
      start = end;
      end = tmp;
    }

    window.location = `?start=${start}&end=${end}`;
  };

  async getUserSDKResource({ start, end }) {
    const uniqid = this.props.uniqid;
    const resource = this.props.resource;
    try {
      const result = await fetch(
        `/api/getSDKResourceByRange?resource=${resource}&uniqid=${uniqid}&start=${start}&end=${end}`,
        {
          mode: "cors",
          method: "GET"
        }
      );

      const data = await result.json();

      // error handling
      this.setState({ users: data });
      this.generateCSV(data);
      console.log(this.state)
      console.log(this.props)
    } catch (err) {
      console.log(err);
    }
  }

  generateCSV(users) {
    const { start, end } = this.state;

    const dates = eachDayOfInterval({
      start: new Date(start),
      end: new Date(end)
    }).map(d => format(new Date(d), "yyyy/MM/dd"));

    const csvData = users.map(u => {
      const ret = {
        serial_number: u.serial_number,
        name: u.name,
      };
      const data = dates.map((d, i) => {
        ret[d] = u.data[i];
      });

      return ret;
    });

    this.setState({ csvData });
  }

  componentDidMount() {
    const start =
      qs.parse(this.props.search, { ignoreQueryPrefix: true }).start ||
      format(subDays(new Date().setHours(0, 0, 0, 0), 6), "yyyy-MM-dd");
    const end =
      qs.parse(this.props.search, { ignoreQueryPrefix: true }).end ||
      format(new Date(), "yyyy-MM-dd");
    this.setState({
      start,
      end,
      selectedStartDate: start,
      selectedEndDate: end
    });
    this.getUserSDKResource({ start, end });
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  render() {
    const { resource, classes } = this.props;
    const {
      selectedStartDate,
      selectedEndDate,
      start,
      end,
      csvDataByReceiveDate,
      receivedatestart,
      receivedateend
    } = this.state;
    let { group_name } = this.props;
    if (typeof this.props.group_name === "string") {
      group_name = group_name.trim();
    }

    return (
      <div className={classes.container}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Paper style={{ marginTop: 60 }}>
            <Grid container className={classes.grid} justify="space-around">
              <DatePicker
                margin="normal"
                label="開始日期"
                value={selectedStartDate}
                onChange={this.handleStartDateChange}
                className={classes.datePicker}
              />
              <DatePicker
                margin="normal"
                label="結束日期"
                value={selectedEndDate}
                onChange={this.handleEndDateChange}
                className={classes.datePicker}
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={this.handlePickerOnClick}
              >
                搜尋
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
              >
                <CSVLink
                  style={{ textDecoration: "none", color: "#ffffff" }}
                  data={this.state.csvData}
                  filename={`${group_name}_${resource}_${start}_${end}`}
                >
                  下載資料
                </CSVLink>
              </Button>
            </Grid>
          </Paper>
        </MuiPickersUtilsProvider>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Paper>
            <Grid container className={classes.grid} justify="space-around">
              <TextField
                id="receivedatestart"
                label="收案日前第幾天"
                className={classes.textField}
                value={receivedatestart}
                onChange={this.handleChange("receivedatestart")}
                margin="normal"
              />
              <TextField
                id="receivedateend"
                label="收案日後第幾天"
                className={classes.textField}
                value={receivedateend}
                onChange={this.handleChange("receivedateend")}
                margin="normal"
              />

              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="frequency">頻率</InputLabel>
                <Select
                  value={this.state.frequency}
                  onChange={this.handleFrequencyChange}
                  inputProps={{
                    name: "frequency",
                    id: "frequency"
                  }}
                >
                  <MenuItem value={"1d"}>一天</MenuItem>
                  <MenuItem value={"1h"}>一小時</MenuItem>
                  <MenuItem value={"1m"}>一分鐘</MenuItem>
                </Select>
              </FormControl>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={this.downloadCSVByReceiveDate}
              >
                收案下載
              </Button>

              <CSVLink
                filename={`${group_name}_綜合資料_${selectedStartDate}_${selectedEndDate}.csv`}
                ref="csvByReceiveDate"
                data={csvDataByReceiveDate}
                style={{ display: "none" }}
              />
            </Grid>
          </Paper>
        </MuiPickersUtilsProvider>

        <Paper className={classes.root}>
          <TableContainer className={classes.container}>
            <Table stickyHeader className={classes.table}>
              <TableHead>
                <TableRow style={{ whiteSpace: "nowrap" }}>
                  <TableCell>個案姓名</TableCell>
                  <TableCell>個案編號</TableCell>
                  {generateTableHead({ start, end })}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.users.map(row => (
                  <TableRow key={row.user_id}>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.serial_number}
                    </TableCell>
                    {row.data.map((s, i) => {
                      let d;
                      d = Number.isInteger(s) ? s : s.toFixed(1);

                      return (
                        <TableCell key={`${d}${i}`} align="right">
                          {d}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(GarminSDK);
